import { FC } from "react"
import { NpFeatureCarouselSection } from "src/components/np-design/sections/feature-carousel/NpFeatureCarouselSection"
import { SlideImageData } from "src/data/product-details/types"

export type GalleryProps = {
  heading: string
  slides: SlideImageData[]
}

export const Gallery: FC<GalleryProps> = NpFeatureCarouselSection
